import { createContext, useContext } from 'react'

interface SidebarCollapseContextValue {
  sidebarHidden: boolean
  setSidebarHidden: (hidden: boolean) => void
}

export const SidebarCollapseContext = createContext<SidebarCollapseContextValue>({
  sidebarHidden: false,
  setSidebarHidden: (_hidden: boolean) => undefined,
})

export const useSidebarCollapse = () => useContext(SidebarCollapseContext)
